import { type AxiosConfig, getAxiosInstances } from './client'
import {
  AcceptedFactApi,
  ApiKeyApi,
  DatapointApi,
  EstimationApi,
  FactApi,
  FeedbackApi,
  IngestionBatchApi,
  IngestionTaskApi,
  KpiApi,
  KpiResultApi,
  MetricApi,
  ResultApi,
  SegmentApi,
  SourceApi,
  SourceBatchApi,
  TechnologyCostApi,
  UnitApi,
  WorkbookApi,
} from './models'

export type ApiConfig = { axios: AxiosConfig }

export type ModelApiName =
  | 'acceptedFact'
  | 'fact'
  | 'ingestionBatch'
  | 'ingestionTask'
  | 'metric'
  | 'segment'
  | 'source'
  | 'sourceBatch'
  | 'unit'
  | 'datapoint'
  | 'technologyCost'
  | 'estimation'
  | 'kpi'
  | 'kpiResult'
  | 'apiKey'

export class Api {
  acceptedFact: AcceptedFactApi
  fact: FactApi
  feedback: FeedbackApi
  ingestionBatch: IngestionBatchApi
  ingestionTask: IngestionTaskApi
  metric: MetricApi
  result: ResultApi
  segment: SegmentApi
  source: SourceApi
  sourceBatch: SourceBatchApi
  unit: UnitApi
  datapoint: DatapointApi
  estimation: EstimationApi
  workbook: WorkbookApi
  technologyCost: TechnologyCostApi
  kpi: KpiApi
  kpiResult: KpiResultApi
  apiKey: ApiKeyApi
  constructor(config: ApiConfig) {
    const {
      facts: factsAxiosInstances,
      modelling: modellingAxiosInstances,
      users: usersAxiosInstances,
    } = getAxiosInstances(config.axios)

    this.acceptedFact = new AcceptedFactApi(factsAxiosInstances)
    this.fact = new FactApi(factsAxiosInstances)
    this.feedback = new FeedbackApi(factsAxiosInstances)
    this.ingestionBatch = new IngestionBatchApi(factsAxiosInstances)
    this.ingestionTask = new IngestionTaskApi(factsAxiosInstances)
    this.metric = new MetricApi(factsAxiosInstances)
    this.result = new ResultApi(factsAxiosInstances)
    this.segment = new SegmentApi(factsAxiosInstances)
    this.source = new SourceApi(factsAxiosInstances)
    this.sourceBatch = new SourceBatchApi(factsAxiosInstances)
    this.unit = new UnitApi(factsAxiosInstances)
    this.kpi = new KpiApi(factsAxiosInstances)
    this.kpiResult = new KpiResultApi(factsAxiosInstances)

    this.datapoint = new DatapointApi(modellingAxiosInstances)
    this.estimation = new EstimationApi(modellingAxiosInstances)
    this.workbook = new WorkbookApi(modellingAxiosInstances)
    this.technologyCost = new TechnologyCostApi(modellingAxiosInstances)

    this.apiKey = new ApiKeyApi(usersAxiosInstances)
  }

  getApiByName(apiName: ModelApiName) {
    return this[apiName]
  }
}
